'use client';

import React, { useState, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import { createRoot } from 'react-dom/client';
import { LiveChatWidget } from '@livechat/widget-react';
import LIVE_CHAT_SETTING from '@configs/liveChatConfig';


export const LiveChatButton = ({ siteName, layoutType }) => {
    const { t } = useTranslation();
    
    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        showLiveChat(siteName);
    };

    return (
        <a className="btn" onClick={handleClick}>
            {layoutType === 'rightNav' ? (
                <>
                    <i className="icon icon--social-live-chat-outline"></i>
                    <span className="text">{t('lbl_LiveChat')}</span>
                </>
            ) : (
                <i className="icon icon--gradient-third">
                    <i className="icon icon--social-live-chat-outline"></i>
                </i>
            )}            
        </a>        
    );
};

function getDeviceType() {
    if (window.innerWidth <= 768) return 'Mobile';
    if (navigator.userAgentData) {
        return navigator.userAgentData.mobile ? 'Mobile' : 'Desktop';
    }
    const ua = navigator.userAgent.toLowerCase();
    return /mobile|android|iphone|ipad|phone/i.test(ua) ? 'Mobile' : 'Desktop';
}

function generateDisplayname(siteName) {      
    const sitePrefix = siteName?.charAt(0).toUpperCase() + siteName?.slice(1);
    const deviceType = getDeviceType();
    
    // 根據 siteName, deviceType 取得對應的 Displayname
    const finalDisplayname = `${sitePrefix}UserNonLogin-${deviceType}`;
    return finalDisplayname;
}

export function showLiveChat(siteName) {    
    const siteSetting = LIVE_CHAT_SETTING[siteName];
    
    // 如果已經打開過，直接最大化開啟
    if (window.LiveChatWidget) {
        window.LiveChatWidget.call('maximize');
        return;
    }

    const handleNewEvent = (event) => { 
        console.log("LiveChatWidget.onNewEvent", event);
    };

    const CustomVisibilityChanged = (data) => {
        switch (data.visibility) {
            case "maximized":
                break;
            case "minimized":
                if (window.LiveChatWidget) {
                    window.LiveChatWidget.call('hide');
                }
                break;
            case "hidden":
                break;
        }
    };

    const widgetElement = (
        <LiveChatWidget
            license={siteSetting.license}
            visibility="maximized"
            customerName={generateDisplayname(siteName)}
            onNewEvent={handleNewEvent}
            onVisibilityChanged={CustomVisibilityChanged}
        />
    );

    const widgetContainer = document.body.appendChild(document.createElement('div'));
    const root = createRoot(widgetContainer);
    root.render(widgetElement);
}

export default { showLiveChat, LiveChatButton };